export const ProductActionTypes = {
    ALL_PRODUCTS: "ALL_PRODUCTS",
    SELECTED_PRODUCT: "SELECTED_PRODUCT",
    REMOVE_PRODUCT: "REMOVE_PRODUCT"
};